import React, { Component } from 'react';
import { Card, Table, Form, Input, Button, Tag } from 'antd';
import { apiUtil as Util } from '../../mock/mockServices';

class Search extends Component {
    state = {
        name: ''
    }
    keyChange = e => {
        this.setState({
            name: e.target.value
        })
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.onSearch({
            name: this.state.name
        })
    }
    handleAdd = () => {
        window.location.href = `../userMgr`;
    }
    render() {
        return (
            <Form layout="inline" className="pt10 pb10">
                <Form.Item label="User Name">
                    <Input style={{ width: '300px' }} onChange={this.keyChange} value={this.state.name} placeholder="Fuzzy search by name" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" onClick={this.handleSubmit}>Search</Button>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" style={{ marginLeft: 'auto' }} onClick={this.handleAdd}>Add</Button>
                </Form.Item>
            </Form>
        )
    }
}
const SearchForm = Form.create({ name: 'orgSearch' })(Search)

class UserList extends Component {
    state = {
        tableLoading: false,
        keyWords: '',
        sorter: {},
        pagination: {
            current: 1,
            pageSize: 20,
            showTotal: total => `${total} items `,
            total: 0
        },
        data: []
    }

    reLoad = () => {
        let pager = { ...this.state.pagination }
        pager.current = 1
        this.setState({
            pagination: pager
        }, () => {
            this.fetch();
        })
    }

    onSearch = keyWords => {
        this.setState({
            keyWords: keyWords
        })
        this.reLoad()
    }

    fetch() {
        const { pagination, keyWords } = this.state
        this.setState({
            tableLoading: true
        })
        Util.ajax.get('/admin/filterUserList', {
            keyWords: keyWords,
            current: pagination.current,
            pageSize: pagination.pageSize
        }).then(res => {
            pagination.total = res.data.total
            this.setState({
                data: res.data.list,
                pagination,
                tableLoading: false
            })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    handleTableChange = (pagination, filters, sorter) => {
        console.log(pagination, sorter);
        
        const pager = { ...this.state.pagination }
        pager.current = pagination.current
        this.setState({
            pagination: pager,
            sorter: {
                orderBy: sorter.field,
                sort:sorter.order === 'ascend' ? 'asc' : 'desc'
            }
        }, () => {
            this.fetch();
        })
    }

    edit = row => {
        window.location.href = `../userMgr?id=${row.id}`;
    }

    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        const columns = [
            {
                title: 'Organization',
                dataIndex: 'orgName',
                width: 220,
            },
            {
                title: 'Login Name',
                dataIndex: 'loginName',
                width: 120,
            },
            {
                title: 'Password',
                dataIndex: 'password',
                width: 120,
            },
            {
                title: 'User Name',
                dataIndex: 'userName',
                width: 180,
            },
            {
                title: 'Mobile',
                dataIndex: 'mobile',
                width: 120,
            },
            {
                title: 'Email',
                dataIndex: 'email',
                width: 180,
            },
            {
                title: 'Remark',
                dataIndex: 'remark',
                width: 180,
            },
            {
                title: 'Assigned Roles',
                dataIndex: 'roleNameList',
                width: 240,
                render: (roleNameList) => {
                    if (!roleNameList) return null;
                    let ids = roleNameList.split(',');
                    return ids.map(id => (
                        <Tag color="blue" key={id}>{id}</Tag>
                    ));
                }
            },
            {
                title: 'Actions',
                dataIndex: 'status',
                key: 'active',
                align: 'center',
                render: (status, row) => {
                    return <Button type="link" onClick={() => this.edit(row)}>Edit</Button>
                }
            }
        ]

        return (
            <div className="page-content" style={{ width: '100%', overflowX: 'scroll' }}>
                <Card title="User - List Management" bordered={ false } style={{ width: '100%', overflowX: 'scroll' }}>
                    <SearchForm onSearch={pms => this.onSearch(pms)}></SearchForm>
                    <Table style={{ width: '100%', borderCollapse: 'collapse' }}
                        rowKey={record => record.id}
                        columns={columns}
                        loading={this.state.tableLoading}
                        dataSource={this.state.data}
                        pagination={this.state.pagination}
                        onChange={this.handleTableChange}
                    />
                </Card>
            </div>
        );
    }
}

export default UserList;